var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-content"},[_c(`rp-${_vm.activeModule}`,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }